module.exports = __webpack_public_path__ + "lato-light-webfont.77425570e1795ddfc657.ttf";


//////////////////
// WEBPACK FOOTER
// C:/WS/Fusion/FusionDashboard/resources/layout/fonts/lato-light-webfont.ttf
// module id = ../../../../../resources/layout/fonts/lato-light-webfont.ttf
// module chunks = styles